import styled from 'styled-components'

import { Color, HEADER_HEIGHT } from 'root-constants'

export const StyledSelectGenderParent = {
  Container: styled.div`
    max-width: 375px;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: calc(${HEADER_HEIGHT}px + 16px) 24px 0;
    margin: 0 auto;
  `,
  Title: styled.p`
    font-size: 32px;
    font-weight: 700;
    line-height: 36px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 16px;
  `,
  QuizLabel: styled.p`
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 24px;
  `,
  CardsContainer: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;

    margin-bottom: 24px;
  `,
  Terms: styled.div`
    width: 100%;
    margin-top: auto;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 20px 0 24px;
    margin: 0;
  `,
}
